(function ($, Drupal, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.kidReviewKidWisdomSlider = {
    attach: function (context, settings) {
      $(once('kidReviewKidWisdomSlider', '.component-kr-kid-wisdom-slide--wrapper', context)).each(function () {
        function kidReviewKidWisdomSlider() {
          $('.component-kr-kid-wisdom-slide--wrapper .field--name-field-kr-slider-slides').not('.slick-initialized').slick({
            arrows: false,
            dots: true,
            centerMode: true,
            focusOnSelect: true,
            mobileFirst: true,
            infinite: true,
            slidesToShow: 1,
            variableWidth: true,
            responsive: [
              {
                breakpoint: 1023,
                settings: 'unslick'
              }
            ]
          }).on('afterChange', function (event, slick, direction) {
            dataLayer.push({
              eventCategory: 'kid reviewed',
              eventAction: 'slide',
              eventLabel: 'kid wisdom',
              eventvalue: '',
              event: 'eventSlide'
            });
            // Revalidate on change
            Drupal.blazy.init.revalidate();
          });
        }

        kidReviewKidWisdomSlider();

        window.addEventListener('resize', function () {
          kidReviewKidWisdomSlider();
        });


      });
    }
  };

  Drupal.behaviors.kidReviewRideSlider = {
    attach: function (context, settings) {
      $(once('kidReviewRideSlider', '.component-kr-kid-wisdom-slide--wrapper', context)).each(function () {
        function kidReviewRideSlider() {
          $('.component-kr-ride-slide--wrapper .field--name-field-kr-slider-slides').not('.slick-initialized').slick({
            arrows: false,
            dots: true,
            centerMode: true,
            focusOnSelect: true,
            mobileFirst: true,
            infinite: true,
            slidesToShow: 1,
            variableWidth: true,
            responsive: [
              {
                breakpoint: 1023,
                settings: 'unslick'
              }
            ]
          }).on('afterChange', function (event, slick, direction) {

            dataLayer.push({
              eventCategory: 'kid reviewed',
              eventAction: 'slide',
              eventLabel: 'rides',
              eventvalue: '',
              event: 'eventSlide'
            });
            // Revalidate on change
            Drupal.blazy.init.revalidate();
          });
        }

        kidReviewRideSlider();

        window.addEventListener('resize', function () {
          kidReviewRideSlider();
        });


      });
    }
  };


})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef



